import React from 'react';
import times from 'lodash/times';
import LoadingMask from '../../../CommonComponents/LoadingMask';
import {
  NetWorthTableGroupHeader,
  NetWorthTableHeader,
  NetWorthTableLabelCell,
  NetWorthTableRow,
  NetWorthTableValueCell,
  StyledNetWorthTable,
} from './NetWorthTableStyles';

const categories = ['Investment Assets', 'Other Assets', 'Liabilities'];

interface Props {}

export const NetWorthTableLoading: React.FC<Props> = () => {
  return (
    <StyledNetWorthTable>
      <NetWorthTableHeader>
        <NetWorthTableLabelCell style={{ fontWeight: 600 }}>Description</NetWorthTableLabelCell>
        <NetWorthTableValueCell style={{ fontWeight: 600 }}>Total</NetWorthTableValueCell>
      </NetWorthTableHeader>
      {categories.map(category => (
        <React.Fragment key={category}>
          <NetWorthTableGroupHeader color="#333">{category}</NetWorthTableGroupHeader>
          {times(2).map(key2 => (
            <NetWorthTableRow key={key2}>
              <NetWorthTableLabelCell>
                <LoadingMask width="300px" height="14px" isDark style={{ marginTop: 4 }} />
              </NetWorthTableLabelCell>
              <NetWorthTableValueCell>
                <LoadingMask width="100px" height="14px" isDark style={{ marginTop: 4 }} />
              </NetWorthTableValueCell>
            </NetWorthTableRow>
          ))}
          <NetWorthTableRow>
            <NetWorthTableLabelCell style={{ fontWeight: 600 }}>Total</NetWorthTableLabelCell>
            <NetWorthTableValueCell>
              <LoadingMask width="100px" height="14px" isDark style={{ marginTop: 4 }} />
            </NetWorthTableValueCell>
          </NetWorthTableRow>
        </React.Fragment>
      ))}
      <NetWorthTableGroupHeader color="#333">
        <NetWorthTableRow>
          <NetWorthTableLabelCell style={{ fontWeight: 700, padding: 0 }}>
            Net Worth
          </NetWorthTableLabelCell>
          <NetWorthTableValueCell style={{ fontWeight: 700, padding: 0 }}>
            <LoadingMask width="100px" height="14px" isDark style={{ marginTop: 4 }} />
          </NetWorthTableValueCell>
        </NetWorthTableRow>
      </NetWorthTableGroupHeader>
    </StyledNetWorthTable>
  );
};
